(function ($, Drupal) {

  Drupal.behaviors.mobileMenu = {

    attach: function (context, settings) {

      once('mobileMenuLoad', '.mobile-menu', context).forEach(function (element, index) {

        // When clicking on top level chevron, show the secondary menu
        var $mobileMenu = $('.mobile-menu');
        var $topLevelLinks = $('.mobile-menu li.menu-item--expanded > a');
        var $topLevelElements = $('.mobile-menu nav > .menu > .menu-item');
        var $secondaryMenus = $('.mobile-menu li.menu-item ul.menu');
        var $logoMenu = $('.logo-menu');
        var $backButton = $('.menu-back');
        var $menuHeading = $('.menu-heading');

        var $menuHeadingOriginalText = $menuHeading[0].innerText;

        // We need the arrows to take us to the second level menu
        // An after pseudo-element would make the most sense
        // but then we can't target a click event on it on staging
        // So instead we'll add a new element and use that
        $topLevelLinks.each(function() {
          $('<button class="arrow"><img src="/themes/sierra/assets/icons/svg/chevron-right-white.svg" alt="View child menu"></button>').insertAfter($(this));
        });

        const $topLevelArrows = $('.mobile-menu .arrow');

        $topLevelArrows.each(function() {
          $(this).click(function () {
            // Show secondary links
            $(this).siblings('ul.menu').addClass('show');
            // Hide top level links
            $topLevelElements.hide();
            // And show this one
            $(this).parent().show();
            // Add a class to use to hide the arrow
            $(this).parent().addClass('hide-arrow');
            // Hide the top level link
            $(this).parent().find('a').first().hide();
            // Update text at the top to be this top level link
            $menuHeading[0].innerText = $(this).parent().find('a')[0].innerText;
            // Show the second level
            $mobileMenu.addClass('second-level-showing');
          });
        })

        function hideSecondaryLinks() {
          // Hide secondary menu
          $secondaryMenus.removeClass('show');
          // Show top level menus again
          $topLevelElements.show();
          // Show the top level link again
          $topLevelLinks.show();
          // Remove the class used to hide the arrow
          $topLevelElements.removeClass('hide-arrow');
          // Put menuHeading text back
          $menuHeading[0].innerText = $menuHeadingOriginalText;
          // Hide back button and show logo
          $logoMenu.removeClass('show');
          // Reset mobile menu class
          $mobileMenu.removeClass('second-level-showing');
        }

        // If you click on the back button,
        // hide the secondary menu and back button, and show the logo
        $backButton.click(function (e) {
          hideSecondaryLinks();
        });
      });

    }

  };

})(jQuery, Drupal);
